import { createContext, useContext, useState } from 'react';

export interface InGameNotificationContextAPI {
    displayNotification: (message: string, displayMs: number) => void;

    notifications: Array<NotificationContainer>;
}

export const InGameNotificationContext = createContext<InGameNotificationContextAPI | undefined>(undefined);

type NotificationContainer = {
    message: string;
    id: number;
};

export function InGameNotificationProvider({ children }: { children: React.ReactNode }) {
    const [notifications, setNotifications] = useState<Array<NotificationContainer>>([]);
    const displayNotification = (message: string, durationMs: number) => {
        const container = { message, id: Math.floor(Math.random() * 1_000_000) };
        setNotifications((prevNotifications) => [...prevNotifications, container]);
        setTimeout(() => {
            setNotifications((notifications) => notifications.filter((notification) => notification !== container));
        }, durationMs);
    };

    return (
        <InGameNotificationContext.Provider value={{ displayNotification, notifications }}>
            {children}
        </InGameNotificationContext.Provider>
    );
}

export function useInGameNotificationContext() {
    const ctx = useContext(InGameNotificationContext);
    if (!ctx) throw new Error('useInGameNotificationContext must be used within a InGameNotificationProvider');
    return ctx;
}
